import React from 'react'
import PropTypes from 'prop-types'

const Arrow = props => (
  <button disabled={props.disabled}
    className={`outline-0 pa0 bn bg-transparent ${props.disabled ? 'not-allowed' : 'pointer'} ${props.className}`}
    onClick={props.onClick}
    style={props.style}
  >
    <img src={props.disabled ? 'assets/chevron-square-disabled.png' : 'assets/chevron-square.png'} />
  </button>
)

export default class Pagination extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    current: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
  }

  onClickPrev = () => {
    this.props.onChange(this.props.current - 1)
  }

  onClickNext = () => {
    this.props.onChange(this.props.current + 1)
  }

  render () {
    const {
      current,
      total,
    } = this.props

    return (
      <div className={this.props.className || ''}>
        <Arrow className='rotate-180 st-mr3'
          disabled={current === 1}
          onClick={this.onClickPrev}
          style={{
            height: '24px',
            width: '24px',
          }}
        />
        <span className='norms-12'>
          {current + ' / ' + total}
        </span>
        <Arrow className='st-ml3'
          disabled={current === total}
          onClick={this.onClickNext}
          style={{
            height: '24px',
            width: '24px',
          }}
        />
      </div>
    )
  }
}
